import { OptionItemSelector } from '@/src/app/main/(tabs)/card/card-management/payment/optionItemSelector'
import { StandaloneWrapper } from '@/src/common/wrappers/StandaloneWrapper'
import { ScrollView, View, Text, StyleSheet } from 'react-native'
import { Link, router } from 'expo-router'
import { Button } from '@/src/common/components/Button'
import { CashForMortgageStore } from '../statsig/store'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { PointsToCashForMortgageGql } from '@/src/experiences/points-to-cash-for-mortgage/gql'
import { MortgageAddress } from '@api/mesa/graphql'
import { useEffect, useCallback } from 'react'
import { Loading } from '@/src/common/components/Loading'
import { fontFamilies, mesaColorNames } from '@/src/common/theme'

function MortgageAddressSelector() {
  const { mortgageAddress, setMortgageAddress } = CashForMortgageStore.useCashForMortgage()

  const { data, loading: loadingAddresses } = useLoggedInQuery(
    PointsToCashForMortgageGql.Queries.GET_MORTGAGE_ADDRESSES,
    { fetchPolicy: 'cache-and-network' },
  )

  const onDataChange = useCallback(() => {
    const address = data?.getMortgageAddresses.addresses[0]
    if (address) {
      setMortgageAddress({
        id: address.id,
        address1: address.address1,
        address2: address.address2,
        city: address.city,
        state: address.state,
        zip: address.zip,
        country: address.country,
        plaidAccount: address.plaidAccount,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => onDataChange(), [onDataChange])
  return (
    <StandaloneWrapper
      screen="/main/points-to-cash-for-mortgage/mortgage-address-selector"
      title="Turn Points into Cash for Your Mortgage"
      profileProps={{ menuIconProps: { color: mesaColorNames['Mesa - Brand/White #FFFFFF'] } }}
    >
      <ScrollView contentContainerStyle={{ paddingBottom: 50 }}>
        <View style={styles.container}>
          <View style={{ rowGap: 5, marginBottom: 10 }}>
            <Text style={styles.title}>Mortgage Address</Text>
            {loadingAddresses && (
              <View style={styles.loadingOverlay}>
                <Loading />
              </View>
            )}

            {!data?.getMortgageAddresses.addresses.length && (
              <View style={styles.noAddressesContainer}>
                <Text style={styles.noAddressesText}>No Addresses Found</Text>
              </View>
            )}

            {data?.getMortgageAddresses.addresses.map((address: MortgageAddress) => {
              const { id, address1, address2, city, state, zip, country, plaidAccount } = address

              return (
                <OptionItemSelector
                  onItemPress={() =>
                    setMortgageAddress({
                      id,
                      address1,
                      address2,
                      city,
                      state,
                      zip,
                      country,
                      plaidAccount,
                    })
                  }
                  key={id}
                  title={`${address1} ${address2 ? `${address2}, ` : ''}${city}, ${state} ${zip}`}
                  isSelected={mortgageAddress?.id === id}
                  subtitle={
                    plaidAccount?.plaidAccountId
                      ? `${plaidAccount.bankAccountLast4} - ${plaidAccount.bankName}`
                      : undefined
                  }
                />
              )
            })}

            <OptionItemSelector
              onItemPress={() => {
                router.push('/main/points-to-cash-for-mortgage/mortgage-address')
              }}
              title="Add new mortgage address"
              isSelected={false}
              withBorder={false}
            />
          </View>
        </View>
      </ScrollView>

      <Link href="/main/points-to-cash-for-mortgage/destination-account" asChild>
        <Button disabled={!mortgageAddress} title="Continue" style={{ marginBottom: 40 }} />
      </Link>
    </StandaloneWrapper>
  )
}

const styles = StyleSheet.create({
  title: {
    fontSize: 14,
    fontFamily: fontFamilies['PlusJakartaSans-Regular'],
    fontWeight: 400,
  },
  container: {
    marginHorizontal: 16,
    position: 'relative',
    backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
    borderRadius: 8,
    padding: 16,
    paddingBottom: 0,
    marginBottom: 24,
  },
  loadingOverlay: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
    opacity: 0.9,
  },
  noAddressesContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 16,
  },
  noAddressesText: {
    color: mesaColorNames['Greyscale/600 #505D64'],
  },
})

export const MortgageAddressSelectorScreen = {
  Screen: MortgageAddressSelector,
  Name: 'mortgage-address-selector',
}
